import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'CustomFieldsFiltersController',
            CustomFieldsFiltersController
        );

    function CustomFieldsFiltersController(
        $scope,
        CompaniesFactory,
        LocalStorageService
    ) {
        var vm = this;

        init();

        function init() {
            getCustomFields();
            onCustomFieldsChanges();
        }

        function getCustomFields() {
            CompaniesFactory.getCustomFields(
                LocalStorageService.getObject('common/company').organization
                    .party_uuid,
                { page_size: 50 }
            ).then(function (response) {
                vm.customFields = response.data.results.filter(function (
                    customField
                ) {
                    return ['multi_choice', 'choice', 'select'].indexOf(customField.field_type) !== -1;
                });
            });
        }

        function onCustomFieldsChanges() {
            $scope.$watch(
                function () {
                    return vm.customFields;
                },
                function () {
                    if (!vm.customFields) {
                        return;
                    }

                    var obj = {};
                    obj['custom_field'] = [];
                    vm.customFieldFilters = vm.customFields
                        .filter(function (field) {
                            return (
                                field.checkboxes &&
                                field.checkboxes.some(function (checkbox) {
                                    return checkbox.checked;
                                })
                            );
                        })
                        .map(function (field) {
                            field.checkboxes.forEach(function (checkbox) {
                                if (checkbox.checked) {
                                    obj['custom_field'].push(
                                        field.id + '::' + checkbox.label
                                    );
                                }
                            });
                            return obj;
                        });
                },
                true
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/custom-fields-filters/custom-fields-filters.controller.ts